import { observable, action } from 'mobx';
import { ApiUrls } from '@app/AppConstants';
import ApiService from '@app/Services/ApiService';
import DateTimeService  from '@app/Services/DateTimeService';
import { ApiV1JobEx, JobStatusMessage } from '@app/Models/WebApiModelsExtend';

class JobStore {
    @observable jobs: ApiV1JobEx[] = [];
    @observable dataLoaded: boolean = false;
    @observable exceptionMessage: string = '';

    @action
    initStore() {
        this.initJobs();
    }

    @action
    initJobs() {
        this.dataLoaded = false;
        this.exceptionMessage = '';
        const jobList = ApiService.getData(ApiUrls.JobList);
        jobList.then((response) => {
            if (response.data.status === 'Started'){
                this.jobs = response.data.jobs || [];
                this.dataLoaded = true;
            } else if (response.data.status === 'FailedToStart'){
                this.exceptionMessage = response.data.startupException;
                this.dataLoaded = true;
            } else if (response.data.status !== 'FailedToStart') {
                window.setTimeout(() => {
                    this.initJobs();
                }, 5000);
            }
        });
    }

    @action
    findTrigger(triggerId: string) {
        for (let i = 0; i < this.jobs.length; i++) {
            const job = this.jobs[i];
            for (let j = 0; j < job.triggers.length; j++) {
                const trigger = job.triggers[j];
                if (trigger.id === triggerId)
                    return trigger;
            }
        }
        return null;
    }

    @action
    updateJobStatus(jobStatus: JobStatusMessage) {
        const trigger = this.findTrigger(jobStatus.triggerId);
        if (trigger) {
            trigger.lastErrorMessage = jobStatus.lastErrorMessage;
            trigger.status = jobStatus.status;
            trigger.progressMessage = jobStatus.progressMessage;
        }

        const job = this.jobs.find(j => j.name === jobStatus.name);
        if (job && DateTimeService.compare(job.timestampDateTimeUtc, jobStatus.timestampDateTimeUtc) < 0) {
            job.lastErrorMessage = jobStatus.lastErrorMessage;
            job.lastStatus = jobStatus.status;
            job.lastRunDateTimeUtc = jobStatus.lastRunDateTimeUtc;
            job.nextRunDateTimeUtc = jobStatus.nextRunDateTimeUtc;
            job.lastRunTriggerName = jobStatus.lastRunTriggerName || '';
            job.nextRunTriggerName = jobStatus.nextRunTriggerName || '';
            job.timestampDateTimeUtc = jobStatus.timestampDateTimeUtc;
        }
    }

    @action
    updateJob(job: ApiV1JobEx) {
        const index = jobStore.jobs.findIndex(x => x.id === job.id);
        if (index !== -1 && DateTimeService.compare(jobStore.jobs[index].timestampDateTimeUtc, job.timestampDateTimeUtc) < 0) {
            jobStore.jobs[index] = job;
        }
        else if (index !== -1) {
            jobStore.jobs[index].triggers = job.triggers;
        }
    }

    updateJobProgressMax(triggerId: string, maxValue: number) {
        const trigger = this.findTrigger(triggerId);
        if (trigger) {
            trigger.progressMaxValue = maxValue;
        }
    }

    updateJobProgressValue(triggerId: string, value: number, maxValue: number) {
        const trigger = this.findTrigger(triggerId);
        if (trigger) {
            trigger.progressMaxValue = maxValue;
            trigger.progressCurrentValue = value;
        }
    }
}
export const jobStore = new JobStore();